<template>
  <div v-show="showLogin" class="modal">
    <div class="modal-inner">
      <div class="close-btn cursor" @click="updateShowLogin(false)">
        <i class="el-icon-close size18 black"></i>
      </div>
      <div class="login_panel_label" v-if="!showRetrievePassword">
        <div class="item" :class="[loginType == item.value ? 'choose' : '']" v-for="(item, i) in loginTypes" :key="i"
          @click="switchLoginType(item.value)">
          {{ item.label }}
        </div>
      </div>
      <!-- <h1 class="size20 black mb10 bold">
        {{ showRetrievePassword ? '找回密码' : isMobileLogin ? "手机快捷登录" : isQrcodeLogin ? "扫码登录" : "账号密码登录" }}</h1> -->
      <h1 class="size20 black mb10 bold" v-show="showRetrievePassword"><i class="el-icon-back size16 cursor"
          @click="switchLoginType('password')"></i> 找回密码
      </h1>
      <span v-if="isMobileLogin" class="size14 colb3">别担心，无账号自动注册不会导致手机号被泄露</span>
      <!-- 找回密码部分 -->
      <div v-if="showRetrievePassword" class="retrieve-password">
        <el-input clearable maxlength="11" placeholder="请输入手机号" v-model="form.mobile" class="moble-input"
          @input="onInput($event, 'mobile')"></el-input>
        <div class="flex sb_center" style="border-bottom:1px solid #eee ;">
          <el-input clearable maxlength="4" @input="onInput($event, 'code')" placeholder="请输入校验码"
            v-model="code"></el-input>
          <img @click="getCodeImg" :src="codeImage" alt="" style="width: 92px;height: 40px;" />
        </div>
        <div class="flex sb_center">
          <el-input clearable maxlength="6" @input="onInput($event, 'vaildCode')" placeholder="请输入短信验证码"
            v-model="form.vaildCode"></el-input>
          <div class="get-code-box">
            <el-button plain @click="onRetrievePasswordSendSms" size="mini" :loading="isLoadingCode"
              :disabled="isDisabled">{{ codeTitle }}</el-button>
          </div>
        </div>
        <el-input class="password-input" clearable maxlength="20" placeholder="请输入密码(最少6位,数字+字母)" v-model="form.password"
          show-password />
      </div>
      <!-- 短信登录部分 -->
      <div v-else-if='isMobileLogin' class="login-input">
        <el-input clearable maxlength="11" placeholder="请输入手机号" v-model="form.mobile" class="moble-input"
          @input="onInput($event, 'mobile')"></el-input>
        <div class="flex sb_center" style="border-bottom:1px solid #eee ;">
          <el-input clearable maxlength="4" @input="onInput($event, 'code')" placeholder="请输入校验码"
            v-model="code"></el-input>
          <img @click="getCodeImg" :src="codeImage" alt="" style="width: 92px;height: 40px;" />
        </div>
        <div class="flex sb_center">
          <el-input clearable maxlength="6" @input="onInput($event, 'vaildCode')" placeholder="请输入短信验证码"
            v-model="form.vaildCode"></el-input>
          <div class="get-code-box">
            <el-button plain @click="onSendSms" size="mini" :loading="isLoadingCode" :disabled="isDisabled">{{ codeTitle
            }}</el-button>
          </div>
        </div>
      </div>
      <!-- 扫码登录部分 - 添加 v-if 确保切换时销毁 -->
      <div v-else-if='isQrcodeLogin' class="qrCodeBox mb10">
        <div class="box" v-loading="qrCode.loading" @click="resetQrCode()" :element-loading-text="returnLoadingText"
          :element-loading-spinner="returnLoadingSpinner" :element-loading-background="returnLoadingBackground">
          <!-- <img v-if="qrCode.data" :src="qrCode.data"> -->
          <div class="qrCodeImg" id="qrCodeImg" title="" ref="qrCodeImg"></div>
        </div>
        <!-- <div class="tip" v-if="qrCode.code == 400">{{ qrCode.tip }}</div> -->
        <div class="tip">
          支持
          <span class="app-name" @mouseenter="showDownAppBox_MouseEnter" @mouseleave="showDownAppBox_MouseLeave">
            {{ companyConfig.firstName + '(小智找房)APP' }}
          </span>
          扫码登录

          <!-- 自定义的提示框 -->
          <div v-if="showDownAppBox" class="custom-tooltip">
            <div class="tooltip-content">
              <p>{{ companyConfig.firstName }}(小智找房)APP下载二维码</p>
              <div class="qr-placeholder">
                <img :src="downloadUrl" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 账号密码登录部分 -->
      <div v-else style="margin: 36px 0 40px;">
        <el-form ref="form" :model="form">
          <el-form-item label="">
            <el-input clearable maxlength="11" placeholder="请输入手机号" @input="onInput($event, 'mobile')"
              v-model="form.mobile"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input placeholder="请输入密码" v-model="form.password" show-password></el-input>
          </el-form-item>
        </el-form>
      </div>
      <a v-if="!isMobileLogin && !showRetrievePassword && !isQrcodeLogin" href="javascript:;" class="green inline-b"
        style="margin-bottom:20px" @click="updateRetrievePassword">忘记密码</a>
      <div class="flex" v-if="!isQrcodeLogin">
        <el-button type="primary" style="border:none;background-color: #00AE66;" class=" flex1"
          @keyup.enter.native="submitForm" @click.prevent="submitForm" :loading="isLoadingLogin">{{ loginTitle
          }}</el-button>
      </div>
      <!-- 移除底部的切换链接，因为功能已经移到上面的 login_panel_label -->
      <div v-if="!showRetrievePassword" class="size12 colb3 mt10 argee-wrap">
        登录及代表同意<router-link class="green" to="/zhuanti/2" target="_blank">《隐私政策》</router-link>及
        <router-link class="green" to="/zhuanti/1" target="_blank">《用户服务协议》</router-link>
      </div>
    </div>

  </div>
</template>
<script>
import userServer from "../services/userServer";
import tool from "../utils/tool.js";
import { mapState } from "vuex";
import { setTimeout } from "timers";
import QRCode from 'qrcodejs2';

export default {
  name: "Login",
  props: {
    onLoad: {
      type: Function,
      default: () => ({})
    }
  },
  data() {
    return {
      loginType: 'mobile',
      loginTypes: [{
        value: 'mobile',
        label: '短信登录'
      },
      {
        value: 'password',
        label: '密码登录'
      },
      {
        value: 'qrcode',
        label: '扫码登录'
      }],
      isLoadingCode: false,
      isLoadingLogin: false,
      isDisabled: false,
      isMobileLogin: true,
      isLoading: false /*  解決多次错误提示 */,
      showRetrievePassword: false, //是否显示找回密码
      isQrcodeLogin: false, // 是否为扫码登录
      form: {
        mobile: "",
        vaildCode: "",
        password: "",
      },
      loginTitle: "登录",
      codeTitle: "获取验证码",
      count: 60,
      timer: null,
      loginBtnRef: null,
      codeImage: "",
      uuid: "",
      code: "",
      showDownAppBox: false,
      qrCodeImg: null,
      qrCode: {
        code: 200,
        tip: '',
        loading: false,
        data: '',
        uuid: '', // 二维码uuid
      },
      qrCode_times: null, //定时器
      qrCodeInstance: null, // 新增：保存QRCode实例
      qrCodeLoadingObj: [
        {
          code: 400,
          text: '失败',
          tip: '扫描失败，请重新扫码登录',
          spinner: 'el-icon-refresh-right',
          background: 'rgba(0, 0, 0, 0.6)',
        },
        {
          code: 401,
          text: '失败',
          tip: '二维码不存在或已过期，请重新扫码登录',
          spinner: 'el-icon-refresh',
          background: 'rgba(255, 255, 255, 0.6)',
        },
        {
          code: 500,
          text: '点击重试',
          tip: '网络异常，请稍后重试',
          spinner: 'el-icon-circle-close',
          background: 'rgba(0, 0, 0, 0.6)',
        },
        {
          code: 501,
          text: '点击重试',
          tip: '二维码过期或不存在',
          spinner: 'el-icon-right',
          background: 'rgba(255, 255, 255, 0.6)',
        },
        {
          code: 200,
          text: '加载中',
          tip: '',
          spinner: '',
          background: 'rgba(255, 255, 255, 0.6)',
        },
        {
          code: 201,
          text: '加载中',
          tip: ' 您已扫描请确认登录',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.6)',
        },
        {
          code: 202,
          text: '加载中',
          tip: '取消登录，点击重新生成二维码',
          spinner: 'el-icon-refresh',
          background: 'rgba(255, 255, 255, 0.6)',
        }
      ]
    };
  },
  computed: {
    ...mapState(["showLogin", "companyConfig"]),
    downloadUrl() {
      return this.companyConfig.downloadUrl
    },
    returnLoadingText() {
      let text = '加载中'
      if (this.qrCode.code == 200 || this.qrCode.code == 401) {
        text = ''
      } else {
        let temp = this.qrCodeLoadingObj.filter((e) => {
          if (e.code == this.qrCode.code) {
            return e
          }
        })
        text = temp[0].text
      }
      return text
    },
    returnLoadingSpinner() {
      let spinner = 'el-icon-loading'
      if (this.qrCode.code == 200 || this.qrCode.code == 201 || this.qrCode.code == 202) {
        spinner = ''
      } else {
        let temp = this.qrCodeLoadingObj.filter((e) => {
          if (e.code == this.qrCode.code) {
            return e
          }
        })
        spinner = temp[0].spinner
      }
      return spinner
    },
    returnLoadingBackground() {
      let background = 'rgba(255, 255, 255, 0.6)'
      if (this.qrCode.code == 200) {
        background = ''
      } else {
        let temp = this.qrCodeLoadingObj.filter((e) => {
          if (e.code == this.qrCode.code) {
            return e
          }
        })
        background = temp[0].background
      }
      return background
    },
  },

  methods: {
    // 新增：鼠标进入事件
    showDownAppBox_MouseEnter() {
      this.showDownAppBox = true;
    },

    // 新增：鼠标离开事件
    showDownAppBox_MouseLeave() {
      // 延迟隐藏，避免立即消失
      setTimeout(() => {
        this.showDownAppBox = false;
      }, 100);
    },
    // 新增：清理二维码相关资源
    cleanupQRCode() {
      // 清除定时器
      if (this.qrCode_times) {
        clearInterval(this.qrCode_times);
        this.qrCode_times = null;
      }

      // 销毁QRCode实例
      if (this.qrCodeInstance) {
        try {
          // QRCode库没有提供直接的销毁方法，所以清空DOM内容
          if (this.$refs.qrCodeImg) {
            this.$refs.qrCodeImg.innerHTML = '';
          }
          this.qrCodeInstance = null;
        } catch (e) {
          console.warn('清理QRCode实例失败:', e);
        }
      }

      // 重置二维码状态
      this.qrCode = {
        code: 200,
        tip: '',
        loading: false,
        data: '', // 清空数据
        uuid: '',
      };
    },
    // 新增：切换登录类型
    switchLoginType(type) {
      // 如果当前是扫码登录，切换到其他类型时清理二维码资源
      if (this.isQrcodeLogin && type !== 'qrcode') {
        this.cleanupQRCode();
      }
      this.loginType = type;

      // 清除定时器
      if (this.qrCode_times) {
        clearInterval(this.qrCode_times);
        this.qrCode_times = null;
      }

      // 根据选择的类型设置对应的状态
      if (type === 'qrcode') {
        this.get_createQr();
        this.isQrcodeLogin = true;
        this.isMobileLogin = false;
        this.showRetrievePassword = false;
      } else if (type === 'mobile') {
        this.getCodeImg()
        this.isQrcodeLogin = false;
        this.showRetrievePassword = false;
        this.isMobileLogin = true;
        this.loginTitle = "登录";
      } else if (type === 'password') {
        this.isQrcodeLogin = false;
        this.showRetrievePassword = false;
        this.isMobileLogin = false;
        this.loginTitle = "登录";
      }
    },

    onInput(value, key) {
      this.form[key] = tool.isNumber(value);
    },
    updateShowLogin(isShow) {
      this.$store.commit("updateState", {
        data: isShow,
        key: "showLogin"
      });
    },
    checkValidate(value) {
      var reg = /^[1-9]\d*|0$/; // 定义正则表达式
      var flag = reg.test(value); // 规则校验
      if (flag) {
        return true;
      } else {
        return false;
      }
    },
    checkMobile(phone) {
      var reg = /^1[3456789]\d{9}$/;
      if (reg.test(phone)) {
        return true;
      } else {
        return false;
      }
    },
    async onMobileLogin() {
      const { mobile, vaildCode } = this.form;
      if (!mobile) {
        this.toast({ message: "请填写手机号" });
        return;
      }
      if (!this.code) {
        this.toast({ message: "请输入校验码" });
        return;
      }
      if (!vaildCode) {
        this.toast({ message: "请输入验证码" });
        return;
      }
      if (
        this.checkMobile(mobile) &&
        this.checkValidate(vaildCode) &&
        vaildCode.length === 4
      ) {
        this.onSubmit(1);
      } else {
        this.isLoadingLogin = false;
        this.toast({ message: "格式错误" });
      }
    },
    onPassWordLogin() {
      const { mobile, password } = this.form;
      if (!mobile) {
        this.toast({ message: "请填写手机号" });
        return;
      }
      if (!password) {
        this.toast({ message: "请输入密码" });
        return;
      }
      if (!this.checkMobile(mobile)) {
        this.toast({ message: "手机号格式错误" });
        return;
      }
      if (password.length < 6) {
        this.toast({ message: "密码长度不能小于6位" });
        return;
      }
      this.onSubmit(2);
    },
    submitForm() {
      if (this.isLoading) return;
      this.isLoading = true;

      if (this.showRetrievePassword) {
        this.updatePassword();
        return;
      }

      if (this.isMobileLogin) {
        this.onMobileLogin();
      } else {
        this.onPassWordLogin();
      }
    },
    updateState({ data, key }) {
      this.$store.commit("updateState", {
        data,
        key
      });
    },
    async onSubmit(type) {
      if (this.isLoadingLogin) return;
      this.isLoadingLogin = true;
      this.loginTitle = "登录中...";
      if (type === 1) {
        this.form.password = "";
      } else {
        this.form.vaildCode = "";
      }
      try {
        const { data } = await userServer.userLogin(this.form);
        this.updateState({ data: false, key: "showLogin" });
        if (data) {
          this.$store.commit("saveUser", data[0]);
        }
      } catch (err) {
        this.toast({ message: err.message });
        type === 1 && this.getCodeImg()
      } finally {
        this.loginTitle = "登录";
        this.isLoadingLogin = false;
        this.codeTitle = "获取验证码";
        this.count = 60;
        this.timer = null;
        this.form = {
          ...this.form,
          vaildCode: "",
          password: ""
        };
        this.isLoading = false;
      }
    },
    onSendSms() {
      const { mobile } = this.form;
      this.clearTimer();
      if (!mobile) {
        return this.toast({
          message: "请填写手机号",
          type: "error"
        });
      }
      let flag = this.checkMobile(mobile);
      if (!flag) {
        return this.toast({
          message: "手机号格式错误",
          type: "error"
        });
      }
      if (!this.code) {
        return this.toast({
          message: "请输入校验码",
          type: "error"
        });
      }
      if (this.isDisabled) return;
      this.isLoadingCode = true;
      this.isDisabled = true;
      userServer
        .sendLoginCode({
          mobile, uuid: this.uuid, code: this.code
        })
        .then(() => {
          this.countDown();
          this.$message({
            type: "success",
            message: "发送成功"
          });
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "发送失败"
          });
          // this.getCodeImg()
          this.isDisabled = false;
        })
        .finally(() => {
          this.isLoadingCode = false;
        });
    },
    onRetrievePasswordSendSms() {
      if (this.isLoading) return;
      this.isLoading = true;
      const { mobile } = this.form;
      this.clearTimer();
      if (!mobile) {
        this.toast({ message: "请填写手机号" });
        return;
      }
      let flag = this.checkMobile(mobile);
      if (!flag) {
        this.toast({ message: "手机号格式错误" });
        return;
      }
      if (this.isDisabled) return;
      this.isLoadingCode = true;
      this.isDisabled = true;
      userServer
        .sendResetPasswordCode({ mobile, uuid: this.uuid, code: this.code })
        .then(() => {
          this.countDown();
          this.toast({ message: "发送成功", type: "success" });
        })
        .catch((err) => {
          this.toast({ message: err.message });
          this.isDisabled = false;
        })
        .finally(() => {
          this.isLoadingCode = false;
          this.isLoading = false;
        });
    },
    countDown() {
      this.timer = setTimeout(() => {
        this.count--;
        this.codeTitle = "获取验证码(" + this.count + ")";
        if (this.count == 0) {
          this.codeTitle = "获取验证码";
          this.isDisabled = false;
          this.count = 60;
        } else {
          this.countDown();
        }
      }, 1000);
    },
    clearTimer() {
      this.timer && clearTimeout(this.timer);
    },
    toast({ message, type = "error", duration = 1500, onClose }) {
      this.$message({
        message,
        type,
        duration,
        onClose: () => {
          this.isLoading = false;
          onClose && onClose();
        }
      });
    },
    updateMobileLogin(type) {
      // 这个方法可以保留，但基本不再使用了
      if (type && type == 'isQrcodeLogin') {
        this.switchLoginType('qrcode');
      } else {
        if (this.showRetrievePassword) {
          this.showRetrievePassword = false;
        } else {
          this.switchLoginType(this.isMobileLogin ? 'password' : 'mobile');
        }
      }
    },
    async updatePassword() {
      const { mobile, vaildCode, password } = this.form;
      if (!mobile) {
        this.toast({ message: "请填写手机号" });
        return;
      }
      if (!vaildCode) {
        this.toast({ message: "请输入验证码" });
        return;
      }
      if (!password) {
        this.toast({ message: "请输入密码" });
        return;
      }
      if (!this.checkMobile(mobile)) {
        this.toast({ message: "手机号格式错误" });
        return;
      }
      if (vaildCode.length !== 4) {
        this.toast({ message: "验证码格式错误" });
        return;
      }
      if (password.length < 6) {
        this.toast({ message: "密码格式不正确" });
        return;
      }
      this.qrCode.loading = true;
      this.isLoadingLogin = true;
      this.loginTitle = "修改中···";
      try {
        const { data } = await userServer.resetPassword(this.form);
        this.toast({
          message: "修改成功!",
          type: "success",
          onClose: () => {
            this.isMobileLogin = false;
            this.showRetrievePassword = false;
            this.isLoadingLogin = false;
          }
        });
      } catch (err) {
        this.toast({
          message: err.message,
          onClose: () => {
            this.isLoadingLogin = false;
          }
        });
      } finally {
        this.loginTitle = "登录";
        this.codeTitle = "获取验证码";
        this.count = 60;
        this.timer = null;
        this.form = {
          ...this.form,
          vaildCode: "",
          password: ""
        };
        this.isLoading = false;
      }
    },
    updateRetrievePassword() {
      this.showRetrievePassword = true;
      this.loginTitle = "修改密码";
    },
    getCodeImg() {
      userServer.getCodeImg().then(res => {
        this.codeImage = "data:image/gif;base64," + res.data.img
        this.uuid = res.data.uuid
      }).catch(err => {
        console.log("getCodeImg :>>", err);
      })
    },
    // 生成二维码
    generateQRCode(obj) {
      // 先清理已有的二维码
      this.cleanupQRCode();
      // 确保 DOM 元素已存在
      if (!this.$refs.qrCodeImg) {
        console.warn('QR Code DOM element not found');
        return null;
      }

      // 清空DOM内容
      this.$refs.qrCodeImg.innerHTML = '';

      try {
        this.qrCodeInstance = new QRCode(this.$refs.qrCodeImg, {
          text: JSON.stringify(obj), //二维码内容字符串
          width: 180, //图像宽度
          height: 180, //图像高度
          colorDark: '#333333', //二维码前景色
          colorLight: '#ffffff', //二维码背景色
          correctLevel: QRCode.CorrectLevel.H, //容错级别
        });
        return this.qrCodeInstance;
      } catch (e) {
        console.error('生成二维码失败:', e);
        return null;
      }
    },
    // 获取二维码
    get_createQr() {
      // 先清理已有的二维码
      this.cleanupQRCode();
      this.qrCode.loading = true;
      this.qrCode.data = ''; // 清空旧数据
      let params = {
        width: 180,
        height: 180
      }
      userServer.createQr(params).then(res => {
        // 使用 $nextTick 确保 DOM 已更新
        this.$nextTick(() => {
          if (this.$refs.qrCodeImg) {
            const qrData = {
              pageName: 'qrCodeLogin',
              uuid: res.data.uuid
            };

            const qrInstance = this.generateQRCode(qrData);
            if (qrInstance) {
              this.qrCode.data = true; // 设置为 true 表示已生成
              this.qrCode.uuid = res.data.uuid;

              this.qrCode.loading = false
              // 立即执行一次检查
              this.get_QrLoginCheck();

              // 改为每1秒轮询一次（原为1000 * 60 = 1分钟）
              this.qrCode_times = setInterval(() => {
                // 只有在扫码登录状态下才轮询
                if (this.isQrcodeLogin) {
                  this.get_QrLoginCheck();
                } else {
                  // 如果不是扫码登录状态，清除定时器
                  this.cleanupQRCode();
                }
              }, 1500); // 1000毫秒 = 1秒
            }
          }

          this.qrCode.loading = false;
        });
      })
    },
    // 轮询获取二维码状态
    get_QrLoginCheck() {
      let params = {
        uuid: this.qrCode.uuid || ''
      }
      userServer.QrLoginCheck(params).then((res) => {
        this.updateState({ data: false, key: "showLogin" });
        if (res.data.length > 0) {
          this.$store.commit("saveUser", res.data[0]);
          // 登录成功后清理二维码资源
          this.cleanupQRCode();
        }

      }).catch((err) => {
        this.qrCode.code = err.code || 500
        this.qrCode.tip = err.message || ''
        if (err.code != 200) {
          this.qrCode.loading = true
        }
      })
    },

    // 刷新二维码
    resetQrCode() {
      // 清除定时器
      if (this.qrCode_times) {
        clearInterval(this.qrCode_times);
        this.qrCode_times = null;
      }

      // 重新生成二维码
      this.get_createQr();
    }
  },

  beforeDestroy() {
    this.clearTimer();
    this.cleanupQRCode(); // 清理二维码资源
  },
  // 新增：组件被隐藏时清理二维码资源
  watch: {
    showLogin: {
      handler(newVal) {
        if (!newVal) {
          // 登录框关闭时清理二维码资源
          this.cleanupQRCode();
        } else {
          this.getCodeImg()
        }
      },
      immediate: true
    }
  },
  created() {
    // this.getCodeImg()
  }
};
</script>

<style scoped>
.argee-wrap a {
  text-decoration: underline;
}

.modal {
  z-index: 9999;
}

.modal-inner {
  width: 380px;
  padding: 50px 40px 44px 40px;
  box-sizing: border-box;
}

.login_panel_label {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 10px;
}

.login_panel_label .item {
  width: 200px;
  list-style: none;
  height: 26px;
  vertical-align: top;
  color: #333;
  font-size: 16px;
  font-weight: 600;
  line-height: 16px;
  cursor: pointer;
  text-align: center;
}

.login_panel_label .item.choose {
  color: #00ae66;
  position: relative;
}

.login_panel_label .item.choose::after {
  content: '';
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0px;
  width: 20px;
  height: 2px;
  border-radius: 4px;
  background-color: #00ae66;
}

.login-input,
.retrieve-password {
  margin: 36px 0 40px;
  border: 1px solid #e6e6e6;
  border-radius: 2px;
}

.moble-input {
  border-bottom: 1px solid #e6e6e6;
}

.login-input>>>.el-input__inner,
.retrieve-password>>>.el-input__inner {
  border: none;
}

.password-input {
  border-top: 1px solid #dcdfe6;
}

.get-code-box>>>.el-button {
  border: none;
}

.get-code-box {
  border-left: 2px solid #ccc;
  border-radius: 2px;
}

.close-btn {
  position: absolute;
  right: 22px;
  top: 22px;
}

.el-button--primary:hover {
  background-color: #00ae66;
}

.qrCodeBox {
  width: auto;
  height: auto;
  padding: 4px;

  .box {
    width: 200px;
    height: 200px;
    box-sizing: border-box;
    border-radius: 10px;
    border: 1px solid #ccc;
    margin: 0 auto;
    padding: 4px;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  img,
  .qrCodeImg {
    width: 180px;
    height: 180px;
    box-sizing: border-box;
    margin: 0 auto;
    border-radius: 2px;
    text-align: center;
  }

  .mark {
    opacity: 0.8;
  }

  .tip {
    margin-top: 10px;
    color: #333;
    font-size: 14px;
    text-align: center;
    position: relative;
    /* 为自定义提示框定位 */
  }

  .app-name {
    color: #00ae66;
    cursor: pointer;
    /* text-decoration: underline; */
    padding: 2px 4px;
    border-radius: 2px;
    transition: background-color 0.3s;
  }

  .app-name:hover {
    background-color: rgba(0, 174, 102, 0.1);
  }

  /* 自定义提示框样式 */
  .custom-tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
    z-index: 10000;
  }

  .custom-tooltip:before {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 6px solid transparent;
    border-top-color: #fff;
  }

  .tooltip-content {
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border: 1px solid #e6e6e6;
    padding: 12px;
    width: 200px;
    text-align: center;
  }

  .tooltip-content p {
    margin: 0 0 10px 0;
    color: #333;
    font-weight: 500;
  }

  .qr-placeholder {
    background: #f5f5f5;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
  }

  .qr-placeholder img {
    width: 140px;
    height: 140px;
  }
}

>>>.el-loading-mask .el-loading-spinner,
>>>.el-loading-mask .el-loading-spinner .el-loading-text,
>>>.el-loading-mask .el-loading-spinner .path {
  color: #00ae66;
  stroke: #00ae66;
}
</style>